"use strict";
module.exports = {
    entityModel: 'order',
    events: {
        ORDER_UPDATED: 'ORDER_UPDATED',
        ORDER_CREATED: 'ORDER_CREATED',
        ORDER_CANCELLED: 'ORDER_CANCELLED',
        ORDER_INVOICED: 'ORDER_INVOICED',
        ORDER_CHANGED_DURING_DELIVERY: 'ORDER_CHANGED_DURING_DELIVERY',
        ORDER_DELIVERED: 'ORDER_DELIVERED',
        ORDER_READY_FOR_SHIPPING: 'ORDER_READY_FOR_SHIPPING',
        ORDER_PLACED: 'ORDER_PLACED',
        ORDER_APPROVED: 'ORDER_APPROVED',
        ORDER_APPROVED_BY_DROPSHIPSUPPLIER: 'ORDER_APPROVED_BY_DROPSHIPSUPPLIER',
        ORDER_WAITING_FOR_RESTOCK: 'ORDER_WAITING_FOR_RESTOCK',
        ORDER_WAITING_FOR_ADMIN: 'ORDER_WAITING_FOR_ADMIN',
        ORDER_WAREHOUSE_PROCESSING_STARTED: 'ORDER_WAREHOUSE_PROCESSING_STARTED',
        ORDER_EXTENDED: 'ORDER_EXTENDED',
        ORDER_SENT: 'ORDER_SENT',
        ORDER_DELIVERY_DATE_CHANGED: 'ORDER_DELIVERY_DATE_CHANGED',
        ORDER_ADVANCE_PAYMENT_RECEIVED: 'ORDER_ADVANCE_PAYMENT_RECEIVED',
        ORDER_MERGED: 'ORDER_MERGED',
        ORDER_DELIVERY_DEVIATION: 'ORDER_DELIVERY_DEVIATION',
        ORDER_OFC_CHANGED: 'ORDER_OFC_CHANGED',
        ORDER_CONNECTED_TO_SUPPLIER_CUSTOMER: 'ORDER_CONNECTED_TO_SUPPLIER_CUSTOMER',
        ORDER_METADATA_CHANGED: 'ORDER_METADATA_CHANGED',
    },
    actions: {
        get: 'v1.order.get',
        list: 'v1.order.list',
        changeOrigin: 'v1.order.changeOrigin',
        placeOrder: 'v1.order.placeOrder',
        sendToWarehouse: 'v1.order.sendToWarehouse',
        changeDeliveryDate: 'v1.order.changeDeliveryDate',
        startWarehouseProcessing: 'v1.order.startWarehouseProcessing',
        setInDraftState: 'v1.order.setInDraftState',
        setInWaitingForRestockState: 'v1.order.setInWaitingForRestockState',
        setInWaitingForAdvancePaymentState: 'v1.order.setInWaitingForAdvancePaymentState',
        setEMCSInformation: 'v1.order.setEMCSInformation',
        markAsReady: 'v1.order.markAsReady',
        setEmailSent: 'v1.order.setEmailSent',
        shipOrder: 'v1.order.shipOrder',
        deliverOrder: 'v1.order.deliverOrder',
        invoiceOrder: 'v1.order.invoiceOrder',
        cancel: 'v1.order.cancel',
        writeOrder: 'v1.order.writeOrder',
        writeSystembolagetOrder: 'v1.order.writeSystembolagetOrder',
        setTrackingCode: 'v1.order.setTrackingCode',
        fortnoxOrder: 'v1.order.fortnoxOrder',
        deviationInDelivery: 'v1.order.deviationInDelivery',
        ensureInvariants: 'v1.order.ensureInvariants',
        pushToState: 'v1.order.pushToState',
        mergeOrder: 'v1.order.mergeOrder',
        approveDropshipOrder: 'v1.order.approveDropshipOrder',
        shipDropshipOrder: 'v1.order.shipDropshipOrder',
        publicCancelOrder: 'v1.order.publicCancelOrder',
        publicApproveOrder: 'v1.order.publicApproveOrder',
        publicChangeOrder: 'v1.order.publicChangeOrder',
        publicGetOrder: 'v1.order.publicGetOrder',
        changeOrderFullfillmentCenter: 'v1.order.changeOrderFullfillmentCenter',
        changeOrderFullfillmentCenterTemporarySolutionForSuper: 'v1.order.changeOrderFullfillmentCenterTemporarySolutionForSuper',
        connectSupplierCustomerToOrder: 'v1.order.connectSupplierCustomerToOrder',
        upsertOrderWithQuantitiesPerColli: 'v1.order.upsertOrderWithQuantitiesPerColli',
        upsert: 'v1.order.upsert',
        upsertWhenEmpty: 'v1.order.upsertWhenEmpty',
        updateWhenEmpty: 'v1.order.updateWhenEmpty',
        update: 'v1.order.update',
    },
    orderStates: {
        draft: 'draft',
        created: 'created',
        received: 'received',
        waitingForRestock: 'waitingForRestock',
        waitingForAdvancePayment: 'waitingForAdvancePayment',
        approved: 'approved',
        approvedByDropshipSupplier: 'approvedByDropshipSupplier',
        inWarehouseProcess: 'inWarehouseProcess',
        readyForShipping: 'readyForShipping',
        enRoute: 'enRoute',
        delivered: 'delivered',
        returned: 'returned',
        invoiced: 'invoiced',
    },
    orderOrigins: {
        supplier: 'supplier',
        export: 'export',
        customer: 'customer',
        systembolaget: 'systembolaget',
        internal: 'internal',
        whitelabel: 'whitelabel',
        purchasing: 'purchasing',
        stockfiller: 'stockfiller',
        dropshipping: 'dropshipping',
        returnToSupplier: 'returnToSupplier',
    },
    deliveryCounties: {
        'SE-O': 'SE-O',
        'SE-N': 'SE-N',
        'SE-M': 'SE-M',
        'SE-K': 'SE-K',
        'SE-I': 'SE-I',
        'SE-H': 'SE-H',
        'SE-G': 'SE-G',
        'SE-F': 'SE-F',
        'SE-E': 'SE-E',
        'SE-D': 'SE-D',
        'SE-C': 'SE-C',
        'SE-Z': 'SE-Z',
        'SE-Y': 'SE-Y',
        'SE-X': 'SE-X',
        'SE-W': 'SE-W',
        'SE-BD': 'SE-BD',
        'SE-T': 'SE-T',
        'SE-S': 'SE-S',
        'SE-U': 'SE-U',
        'SE-AC': 'SE-AC',
        'SE-AB': 'SE-AB',
    },
    orderTypes: {
        Order: 'Order',
        Backorder: 'Backorder',
        ReturnOrder: 'ReturnOrder',
    },
    termsOfPayments: {
        0: '0',
        10: '10',
        15: '15',
        20: '20',
        30: '30',
        35: '35',
        60: '60',
        70: '70',
        A: 'A',
        K: 'K',
        PF: 'PF',
    },
    transportProviders: {
        POSTNORD: 'POSTNORD',
        BUDCOMPANIETT: 'BUDCOMPANIETT',
        DLP: 'DLP',
        DSV: 'DSV',
    },
    deliveryPalletTypes: {
        SRS_EUR6: 'SRS_EUR6',
        SRS_EPAL: 'SRS_EPAL',
        EPAL: 'EPAL',
        QUARTER_PALLET: 'QUARTER_PALLET',
        EUR6: 'EUR6',
        OTHER: 'OTHER',
    },
    orderFlowTypes: {
        standard: 'standard',
        email: 'email',
        freshx: 'freshx',
    },
    orderRows: {},
};
